import React, { useEffect, useState } from 'react';
import './About.css';
import axios from 'axios';
const About = () => {
  const [data, setData] = useState([]);
  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getabout'
    );
    setData(res.data);
  };
  useEffect(() => {
    getdata();
  }, []);
  return (
    <>
      <div className="about">
        <h2 className="p-3">About Me</h2>
        <br />
        {data && (
          <div className="container">
            {data?.map((val, ind) => {
              return (
                <>
                  <div className="row" key={ind}>
                    <div className="col-md-6 col-12 mx-auto mb-3 d-flex justify-content-center align-items-center">
                      <img src={val.image} alt="about" className="aboutimg" />
                    </div>
                    <div className="col-md-6 col-12 mx-auto mb-3 d-flex justify-content-center align-items-center">
                      <p>
                        I am <strong>Atanu Jana</strong>, an{' '}
                        <strong>avid web developer (MERN STACK)</strong> and
                        highly <strong>enthusiastic</strong> to work in the
                        fields related to web development .{' '}
                        <strong>
                          Looking forward for better opportunities.{' '}
                        </strong>{' '}
                        Now I am in 3rd year,Techno Main Saltlake,Kolkata.{' '}
                        <br /> I also work as a <strong>FREELANCER. </strong>{' '}
                        <br /> In Front-end i know :{' '}
                        <strong>
                          HTML5, CSS3, JS , BOOTSTRAP , REACT JS.{' '}
                        </strong>{' '}
                        <br /> In Back-end i know:{' '}
                        <strong>PHP, NODEJS ,EXPRESS JS, Laravel 8. </strong>{' '}
                        <br /> In Database i know:{' '}
                        <strong>MYSQL , MONGODB. </strong>
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default About;
